
function Loading({ children, component, loading }: any) {
	if (loading) return component;
	return children;
}

export default Loading;
